/* eslint-disable react-hooks/exhaustive-deps */
import React,{useMemo,useState, useContext} from "react";
import moment from  'moment';
import {SectorRenderer} from "../../sales/inner-components/renderers";
import { formatDateByTimezone} from '../../../utils/commonFunctions';
import {ThemeContext} from '../../../contexts/themeContext';
import { MdOutlineFlightTakeoff } from "react-icons/md";
import { MdFlightLand } from "react-icons/md";

const CountTable = (props) => {

  return (<>  {props.mode==='paxSummary'?showPaxSummary(props):showSectorCapacity(props)}</>
  )
}
const showPaxSummary = (px) => {
  const { paxSum, headcountManifest } = px;
  const allZero = !paxSum?.ecy && !paxSum?.pc && !paxSum?.bc && !paxSum?.fc;

  const cabins = [
    { label: 'Economy',         occupied: allZero ? headcountManifest?.headcount : paxSum?.ecy },
    { label: 'Premium Economy', occupied: allZero ? null : paxSum?.pc },
    { label: 'Business Class',  occupied: allZero ? null : paxSum?.bc },
    { label: 'First Class',     occupied: allZero ? null : paxSum?.fc },
  ];

  return (
    <div className="cabin-summary-grid">
      {cabins.map((cabin) => (
        <div key={cabin.label} className="cabin-card">
          <span className="cabin-label">{cabin.label}</span>
          {cabin.occupied == null ? (
            <span className="cabin-no-data">No data available</span>
          ) : (
            <div className="cabin-row">
              <span className="cabin-key">Occupied:</span>
              <span className="cabin-val bold">{cabin.occupied}</span>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};


const showSectorCapacity = (px) => {
  const { status } = px;

  const breakdownMap = {};
  status?.breakdown?.forEach(b => {
    breakdownMap[b.category] = b.headcount;
  });

  const allZero = status?.breakdown?.every(b => b.headcount === 0);

  const cabins = [
    { label: 'Economy',         key: 'EC' },
    { label: 'Premium Economy', key: 'PE' },
    { label: 'Business Class',  key: 'BC' },
    { label: 'First Class',     key: 'FC' },
  ];

  return (
    <div className="cabin-summary-grid">
      {cabins.map((cabin) => {
        const occupied = allZero
          ? (cabin.key === 'EC' ? status?.headcount : null)
          : breakdownMap[cabin.key];

        return (
          <div key={cabin.label} className="cabin-card">
            <span className="cabin-label">{cabin.label}</span>
            {occupied == null ? (
              <span className="cabin-no-data">No data available</span>
            ) : (
              <div className="cabin-row">
                <span className="cabin-key">Occupied:</span>
                <span className="cabin-val bold">{occupied}</span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
export const CateringSummary = (props) => {
  const { group, timezone, getCorrectedTailNo, tailNumber} = props;

const [expandSector,setExpandSector] = useState(null);
  const {themedColor} = useContext(ThemeContext);

const toggleSector = (sectorId) => {
  setExpandSector(prev =>prev === sectorId ? null : sectorId);
};
const getEffectiveTimes = (sector) => {
  if (sector?.etd && sector?.eta) {
    return { depTime: sector.etd, arrTime: sector.eta, depLabel: 'ETD', arrLabel: 'ETA' };
  } else if (sector?.atd && sector?.ata) {
    return { depTime: sector.atd, arrTime: sector.ata, depLabel: 'ATD', arrLabel: 'ATA' };
  }
  else if (sector?.rtd && sector?.rta) {
    return { depTime: sector.rtd, arrTime: sector.rta, depLabel: 'RTD', arrLabel: 'RTA' };
  }
   else {
    return { depTime: sector.std, arrTime: sector.sta, depLabel: 'STD', arrLabel: 'STA' };
  }
};

const rotationTimes = useMemo(() => {
  if (!group?.length) return { start: null, end: null };

  let latestEstMap = {};
  let paxSum = 0;
  let categoryPax = { BC: 0, EC: 0, FC: 0, PE: 0 };
  let byLegMap = {};

  const sorted = [...group].sort((a, b) => new Date(a.item.startTime) - new Date(b.item.startTime));
  const first = sorted[0];
  const last  = sorted[sorted.length - 1];

  group.forEach(g => {
    g.item?.sectors?.forEach(sector => {
      latestEstMap[sector.id] = g.item;
    });

    g.item?.latestEstimate?.headcountManifest?.byLeg?.forEach(leg => {
      byLegMap[leg.legId] = leg;

      leg.breakdown?.forEach(({ category, headcount }) => {
        categoryPax[category] = (categoryPax[category] || 0) + headcount;
      });
    });
  });

  paxSum = group.reduce((sum, g) => {
    return sum + (g?.item?.latestEstimate?.headcountManifest?.headcount ?? 0);
  }, 0);

  const tailNo = group.map(g => g.item?.latestEstimate?.tailNumber).find(Boolean) ?? tailNumber;

  return {
    date: first?.item?.date,
    startTime: first?.item?.startTime,
    endTime: last?.item?.endTime,
    groupName: group[0]?.item?.groupName ?? group?.groupName ?? "",
    sectorGroup: group.flatMap(g => g.item?.sectors || []),
    latestEstimates: latestEstMap,
    byLegMap,         
    tailNumber:tailNo,        
    paxSum: isNaN(paxSum) ? '' : paxSum,
    categoryPax,
  };
}, [group, tailNumber]);


  return (
<div className="flexCol cntrl-calender-summary op-aircraft-container ng-grid-right flexCol full-flex ag-theme-alpine-dark">
  <div>
    <div className='table-header'></div>
    <table>
      <tbody>
        <tr>
          <td>
         <div className="flight-summary-card">

  <div className="flight-summary-header">
    <div className="tail-badge">
      ✈ {rotationTimes.tailNumber ? getCorrectedTailNo(rotationTimes.tailNumber) : '—'}
    </div>
    <div className="op-date">
      {moment(formatDateByTimezone(new Date(rotationTimes?.date)))
        .format('DD MMM YYYY')}
    </div>
  </div>

<div className="flight-summary-time">

  <div className="time-block">
    <span className="time-date">
      {moment(rotationTimes?.startTime).format("DD MMM")}
    </span>
    <span className="time-value">
      {moment.utc(formatDateByTimezone(
        new Date(rotationTimes?.startTime),
        timezone === 'utc', true
      )).format("hh:mm A")}
    </span>
    <span className="time-label">START</span>
  </div>

  <div className="time-line">
    <MdOutlineFlightTakeoff />
    <span className="line" />
    <MdFlightLand />
  </div>

  <div className="time-block right">
    <span className="time-date">
      {moment(rotationTimes?.endTime).format("DD MMM")}
    </span>
    <span className="time-value">
      {moment.utc(formatDateByTimezone(
        new Date(rotationTimes?.endTime),
        timezone === 'utc', true
      )).format("hh:mm A")}
    </span>
    <span className="time-label">
      END
      {moment(rotationTimes?.endTime).diff(moment(rotationTimes?.startTime), 'days') > 0 && (
        <span className="day-shift"> (+1)</span>
      )}
    </span>
  </div>

</div>
<div className="block-time-badge alignItemsCenter flexRow justifyContentCenter">{rotationTimes?.groupName ?? ""}</div> 
</div>
          </td>

          <td>
            <label className="fontExtrabold margBottom10">Pax Summary</label>
              <CountTable
              flightDetails={null}
              mode={"paxSummary"}
              paxSum={{
              ecy: rotationTimes?.categoryPax?.EC,
              pc:  rotationTimes?.categoryPax?.PE,
              bc:  rotationTimes?.categoryPax?.BC,
              fc:  rotationTimes?.categoryPax?.FC,
              }}
              headcountManifest={{ headcount: rotationTimes?.paxSum }}
              capacity={rotationTimes?.capacity} //seat max capacity
              />
          </td>
        </tr>

        <tr>
          <td colSpan={2} className="spl-row-class fontExtrabold" style={{ textAlign: 'center' }}>
            Sector Details
          </td>
        </tr>

        {group?.flatMap(g => g.item?.sectors || [])?.map((sector, index) => {
          const { depTime, arrTime, depLabel, arrLabel } = getEffectiveTimes(sector);
          const legStatus = rotationTimes.byLegMap?.[sector.id] ?? null;
          const isExpanded = expandSector === sector.id;

          const depMoment = moment(depTime);
          const arrMoment = moment(arrTime);
          const timeDifference = moment.duration(arrMoment.diff(depMoment));
          const hours = Math.floor(timeDifference.asHours());
          const min = timeDifference.minutes();

          return (
            <React.Fragment key={sector.id}>
              <tr key={index} style={{ cursor: 'pointer' }} onClick={() => toggleSector(sector.id)}>
                <td>
                  <div className="flight-time-card">
                    <div className="flight-time-header">   
                    {SectorRenderer({ data: sector })}
                      <span className="caption-regular">
                        {(() => {
                          const flightDate = moment(sector.flightDate);
                          const staDate = moment(arrTime);
                          const dayDifference = staDate.startOf("day").diff(flightDate.startOf("day"), "days");
                          return (
                            <>
                              {flightDate.format("DD-MM-YYYY")}
                              <strong style={{ color: '#31a8ff' }}>
                                {dayDifference > 0 && ` (+${dayDifference})`}
                              </strong>
                            </>
                          );
                        })()}
                      </span>
                    </div>

                    <div className="flight-time-row">

                      <div className="flight-time-block">
                        <span className="flight-time-value">
                          {moment.utc(formatDateByTimezone(new Date(depTime), timezone === 'utc' ? true : false, true)).format("hh:mm A")}
                        </span>
                        <span className="flight-time-label">{depLabel}</span>
                      </div>

                      <div className="flight-time-middle">

                        <div className="flight-time-line">
                          <MdOutlineFlightTakeoff />
                          <span className="flight-dashes" /> 
                          <MdFlightLand/>
                        </div>

                        <div className="block-time-badge"
                         aria-label={'Flight Duration'}
                         title={'Flight Duration'}
                        >
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" style={{ marginRight: '4px' }}>
                            <circle cx="12" cy="12" r="10" stroke="#fff" strokeWidth="2"/>
                            <path d="M12 6v6l4 2" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
                          </svg>
                          Flight Duration&nbsp;<strong>{`${hours}h ${min}m`}</strong>
                        </div>
                      </div>

                      <div className="flight-time-block right">
                        <span className="flight-time-value">
                          {moment.utc(formatDateByTimezone(new Date(arrTime), timezone === 'utc' ? true : false, true)).format("hh:mm A")}
                        </span>
                        <span className="flight-time-label">{arrLabel}</span>
                      </div>

                    </div>

                    <div className='flexRow justifyContentSpaceBetween margTop18'>
                      <div className='flexCol margRight15'>
                        <label className='fontExtrabold margBottom10'>Status</label>
                        <div className="status-dynamic" style={{ backgroundColor: '#1d3f4f' }}>
                          {sector.flightStatus.charAt(0).toUpperCase() + sector.flightStatus.slice(1)}
                        </div>
                      </div>

                      <div className='flexCol margRight15'>
                        <label className={`fontExtrabold ${!sector?.totalArrivalDelay ? 'margBottm20' : 'margBottom10'}`}>
                          Arr Delay
                        </label>
                        {sector?.totalArrivalDelay
                          ? <div className="status-dynamic" style={{ backgroundColor: '#b73021ff' }}>
                              {`${sector.totalArrivalDelay.formattedValue} ${sector.totalArrivalDelay.unit}`}
                            </div>
                          : <span className="flexRow justifyContentCenter alignItemsCenter">---</span>
                        }
                      </div>

                      <div className='flexCol'>
                        <label className={`fontExtrabold ${!sector?.totalDepartureDelay ? 'margBottm20' : 'margBottom10'}`}>
                          Dep Delay
                        </label>
                        {sector?.totalDepartureDelay
                          ? <div className="status-dynamic" style={{ backgroundColor: '#c17a1eff' }}>
                              {`${sector.totalDepartureDelay.formattedValue} ${sector.totalDepartureDelay.unit}`}
                            </div>
                          : <span className="flexRow justifyContentCenter alignItemsCenter">---</span>
                        }
                      </div>
                    </div>

                  </div>


                </td>

                <td style={{ background: isExpanded && expandSector === sector.id ? themedColor.background : '' }}>
                  <CountTable
                    mode="paxSectors"
                    status={legStatus || null}
                  />
                </td>
              </tr>

              {isExpanded && (
                <tr>
                  <td colSpan={2} style={{ background: themedColor.background }}>

                    <label className='fontExtrabold margBottom10'>Operating Crew</label>
                    {sector.crew?.length ? (
                      <div className="crew-container">
                        {sector.crew.map((member, idx) => (
                          <div key={member.employeeCode || idx} className="employee-crew">
                            <div className="crew-avatar">
                              <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" width="36" height="36">
                                <circle cx="20" cy="20" r="20" fill="#1d3f4f"/>
                                <circle cx="20" cy="15" r="7" fill="#4a90a4"/>
                                <path d="M6 36c0-7.732 6.268-14 14-14s14 6.268 14 14" fill="#4a90a4"/>
                              </svg>
                            </div>
                            <div title={member?.name} className="crew-info">
                              <span className="crew-name">{member.name}</span>
                              <span className="crew-code">{member.employeeCode}</span>
                            </div>
                            <div className="crew-role-badge">
                              {member.position ? `${member.role} @ ${member.position}` : member.role}
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="flexRow margBottm20">
                        No information about operating crew available.
                      </div>
                    )}


                  </td>
                </tr>
              )}
            </React.Fragment>
          );
        })}
      </tbody>
    </table>
  </div>
</div>
  )
}